import React, { useState, useEffect } from "react";

import { InputGroup, Col, Row, Button, Modal } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import AddBoxIcon from '@mui/icons-material/AddBoxOutlined';
import DeleteIcon from "@mui/icons-material/Delete";
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import TextFormatIcon from '@mui/icons-material/TextFormat';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PostAddIcon from '@mui/icons-material/PostAdd';
import Select from "react-select";
import ApiAmusementService from "../../../core/api/api.amusementService";
import _ from "lodash";
import { styled } from '@mui/material/styles';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';


const AmusementInactiveSessions = () => {
  const [modaAddNewEditField, setModaAddNewEditField] = useState(false);
  const [selectedNode, setSelectedNode] = useState({ id: null, name: "", type: "" });
  const [selectedShowNode, setSelectedShowNode] = useState({ id: null });
  const [formInputs, setFormInputs] = useState(
    { place: null, service: null }
  );
  const [actionType, setActionType] = useState({});
  const [reserveDetails, setReserveDetails] = useState({});
  const [treeViewData, setTreeViewData] = useState({});
  const [services, setServices] = useState([]);
  const [places, setPlaces] = useState([]);

  const useStyles = styled({
    root: {
      padding: '30px 10px',
      width: 'auto',
      display: 'inline-block',

    },
  });
  const classes = useStyles();



  let counter = 0;

  StyledTreeItem.propTypes = {

    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
  };
  //============================================End Difinition Parameter=================================================

  // دریافت لیست سرویس ها
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data))
          setServices(data);
      } catch (error) {
        // 
      } finally {
      }
    })();
    return () => { };
  }, []);

  // تغییر سرویس یا مکان
  const inputChangeHandler2 = (event) => {
    //setValue("service", event);
    if (event?.type !== "service") {
      setFormInputs({
        ...formInputs,
        [event?.type]: event
      });
    }
    else {
      setPlaces(services.find((e) => e.id === event.value).amusementServiceAmusementPlaces);
      setFormInputs({
        ["formInputs.place"]: null,
        [event?.type]: event,
      });
    }
    setReserveDetails(null);
    setTreeViewData(null);
    setSelectedNode({ id: null, name: "", type: "" });
  }

  // انتخاب مکان برای سرویس انتخاب شده 
  // تغییر مکان ها در صورت تغییر سرویس انتخاب شده
  useEffect(() => {
    (async () => {
      try {

        if (_.isNumber(formInputs.service.value)) {
          let reserveDetails = services.filter((x) => x.id === formInputs.service.value)[0].reserveDetails;
          if (!_.isEmpty(reserveDetails)) {
            reserveDetails = JSON.parse(reserveDetails);
            let treeViewLocalData = JSON.parse(JSON.stringify(reserveDetails));
            // حذف بقیه مکان ها و تنها نگه داشتن نود مکان انتخاب شده در صورت وجود
            if (_.isNumber(formInputs?.place?.value) && reserveDetails.Child) {

              treeViewLocalData.Child.forEach((item, index) => {
                if (item.AmusmentLocationId !== formInputs.place.value)
                  delete treeViewLocalData.Child[index];
              });
            }
            setTreeViewData(treeViewLocalData);

          }
          setReserveDetails(reserveDetails);
        }
      } catch (error) {

      } finally {
      }
    })();
    return () => { };
  }, [formInputs, services]);



  const useTreeItemStyles = styled((theme) => ({
    root: {
      color: theme.palette.text.secondary,
      '&:hover > $content': {
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus > $content, &$selected > $content': {
        backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
        color: 'var(--tree-view-color)',
      },
      '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
        backgroundColor: 'transparent',
      },
    },
    content: {
      color: theme.palette.text.secondary,
      borderTopRightRadius: theme.spacing(2),
      borderBottomRightRadius: theme.spacing(2),
      paddingRight: theme.spacing(1),
      fontWeight: theme.typography.fontWeightMedium,
      '$expanded > &': {
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    group: {
      marginLeft: 0,
      '& $content': {
        paddingLeft: theme.spacing(2),
      },
    },
    expanded: {},
    selected: {},
    label: {
      fontWeight: 'inherit',
      color: 'inherit',
    },
    labelRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0.5, 0),
    },
    labelIcon: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
    },
    // labelText: {
    //   fontWeight: 'inherit',
    //   flexGrow: 1,
    // },
  }));

  function StyledTreeItem(props) {
    const classes = useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

    // return (
    //   <TreeItem
    //   // draggable
    //     label={
    //       <div className={classes.labelRoot}>
    //         <LabelIcon color="inherit" className={classes.labelIcon} />
    //         <Typography variant="body2" className={classes.labelText}>
    //           {labelText}
    //         </Typography>
    //         <Typography variant="caption" color="inherit">
    //           {labelInfo}
    //         </Typography>
    //       </div>
    //     }

    //     {...other}
    //   />
    // );
  }

  //ساخت درخت سرویس
  const renderTree = (nodes) =>
  (
    //برای چک خوردن دکمه رادیو از RadioButtonCheckedIcon استفاده شود
    //برای چک خوردن دکمه چک باکس از CheckBoxIcon استفاده شود
    <StyledTreeItem nodeId={`${nodes.Id}`} key={`${nodes.Id}`} labelIcon={nodes.Type == "Radio" ? RadioButtonUncheckedIcon : nodes.Type == "Text" ? TextFormatIcon : (nodes.Type == "CheckBox" ? CheckBoxOutlineBlankIcon : (nodes.Type == "Location" ? LocationOnIcon : (nodes.Type == "Service" ? PostAddIcon : CheckBoxOutlineBlankIcon)))}
      labelText={nodes.Text} CustomDate={nodes.CustomDate} onLabelClick={(event) => {
        setSelectedNode({ id: nodes.Id, name: nodes.Text, type: nodes.Type });
        setSelectedShowNode(nodes);
      }}

    >
      {Array.isArray(nodes.Child) ? nodes.Child.map((node) => renderTree(node)) : null}

    </StyledTreeItem>
  );



  const selectStyles = {

    menu: base => ({
      ...base,
      zIndex: 10000
    })
  }
  return (
    <div>
      <div className={`card card-custom`}>
        <div className="card-body pt-3 pb-0 border-top">
          <form noValidate autoComplete="off" className="mt-3">
            <Col xs="12" style={{ zIndex: '3' }}>
              <Select
                name="service"
                style={selectStyles}
                inputId="react-select-with-search"
                className="w-100 mt-2"
                variant="outlined"
                size="small"
                placeholder="انتخاب سرویس"
                TextFieldProps={{
                  label: "Countries",
                  InputLabelProps: {
                    htmlFor: "react-select-multiple",
                    shrink: true,
                  },
                }}
                options={services?.map((item) => (
                  {
                    value: item.id,
                    label: item.name,
                    type: "service"
                  }
                ))}
                value={formInputs.service || ""}
                onChange={inputChangeHandler2}
              />
            </Col>


            {reserveDetails !== null ?
              <>
                <Row className="mx-0">
                  <Col xs={6} className="pr-lg-0">
                    {/* <TreeView
                      className={classes.root}
                      defaultCollapseIcon={<IndeterminateCheckBoxIcon />}
                      defaultExpanded={['root']}
                      defaultExpandIcon={<AddBoxIcon />}
                    >
                      {!_.isEmpty(treeViewData) ?
                        renderTree(treeViewData)
                        : <></>}
                    </TreeView> */}
                  </Col>
                  <Col xs={6} className="pr-lg-0">
                    {/* {_.isNumber(selectedShowNode.Id) ?
                      <ShowFormField
                        selectedService={(!_.isEmpty(services.find((e) => e.id === formInputs.service?.value)) ? services.find((e) => e.id === formInputs.service?.value).name : null)}
                        selectedPlace={(!_.isEmpty(places.find((e) => e.amusementPlaceId === formInputs.place?.value)) ? places.find((e) => e.amusementPlaceId === formInputs.place?.value).amusementPlaceName : null)}
                        // reserveDetails={reserveDetails}
                        selectedNode={selectedShowNode}
                      /> : <></>
                    } */}
                  </Col>
                </Row>
              </>
              : null}
          </form>
        </div>
      </div>



    </div>
  );
};
export default AmusementInactiveSessions;